import { TMessage, EOutcomingStatus, TOutcomingMessage, TMessageSchema } from '../../types/messages';
import { mapCommonMessageFields } from './mapCommonMessageFields';
import { isMessageRead } from './isMessageRead';

export function mapMessageToOutgoing(existingMessage: TMessage, rawMessage: TMessageSchema): TOutcomingMessage {
  const message = mapCommonMessageFields(rawMessage, existingMessage);
  const isRead = isMessageRead({ rawMessage, isOutcoming: true });

  return {
    ...message,
    isRead,
    status: isRead ? EOutcomingStatus.Read : EOutcomingStatus.Fulfilled,
  };
}
